import React, { useState, useEffect, useCallback } from 'react';
import StatusBadge from '../../components/whatsapp/StatusBadge';
import TestMessageCard from '../../components/whatsapp/TestMessageCard';
import { getSessionStatus } from '../../api/whatsapp/portalWhatsAppApi';
import {
  Card,
  CardContent,
} from '../../components/ui';

const PortalWhatsAppPage = ({ schoolId }) => {
  const [status, setStatus] = useState('DISCONNECTED');

  const fetchStatus = useCallback(async () => {
    try {
      const res = await getSessionStatus(schoolId);
      if (res.success) setStatus(res.status);
    } catch (err) {
      console.error('Error fetching session status:', err);
    }
  }, [schoolId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4 sm:p-6 lg:p-8">
      {/* Channel Header Card */}
      <Card>
        <CardContent className="flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-1">
            <h1 className="text-xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100 sm:text-2xl">
              WhatsApp Channel Status
            </h1>
            <p className="text-sm text-neutral-500 dark:text-neutral-400">
              Live connection status for staff dispatches and system notifications.
            </p>
          </div>
          <div className="shrink-0">
            <StatusBadge status={status} />
          </div>
        </CardContent>
      </Card>

      {/* Manual Test Dispatch Card */}
      <TestMessageCard />
    </div>
  );
};

export default PortalWhatsAppPage;